import type { ReactNode } from 'react';

export const symbol_carry_on_bag: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M633-280q50 0 85 35t35 85q0 50-35 85t-85 35q-44 0-77.5-26.5T516-135H292q-24.75 0-42.37-17.63Q232-170.25 232-195v-409q0-24.75 17.63-42.38Q267.25-664 292-664h281v-156h-54q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h84q12.75 0 21.38 8.62Q633-862.75 633-850v570Zm-275 85v-409h-66v409h66Zm60-409v409h99q6.55-22.13 21.27-40.56Q553-254 573-265v-339H418Zm264.5 493.62q20.5-20.38 20.5-49.5t-20.38-49.62q-20.38-20.5-49.5-20.5t-49.62 20.38q-20.5 20.38-20.5 49.5t20.38 49.62Q603.76-90 632.88-90t49.62-20.38ZM633-165ZM418-400Zm-60 205v-409 409Zm60-409v409-409Z"
		/>
	</svg>
);
